export function resetTurnstileToken() {
  window.turnstile?.reset();
}
